import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Tooltip } from '@chakra-ui/react';
import { observer } from 'mobx-react';

const ViewerPasswordDialog = (props) => {

    const [show, setShow] = React.useState(false)
    const handleShowPasswordClick = () => setShow(!show)
    const [password, setPassword] = React.useState(undefined);

    return (

        <Modal isOpen={props.open} onClose={()=>{}} motionPreset="slideInBottom" blockScrollOnMount={false} autoFocus={false} returnFocusOnClose={false} isCentered scrollBehavior={'inside'}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Password Required </ModalHeader>
                {/* <ModalCloseButton /> */}
                <ModalBody overflowX={'hidden'} >
                    <InputGroup size='md'>
                        <Input
                            pr='4.5rem'
                            type={show ? 'text' : 'password'}
                            placeholder='Enter password'
                            onChange={event => setPassword(event.target.value)}
                        />
                        <InputRightElement width='4.5rem'>
                            <Button h='1.75rem' size='sm' onClick={handleShowPasswordClick}>
                                {show ? 'Hide' : 'Show'}
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='blue' isDisabled={password == undefined} isLoading={props.evStore.isLoading} onClick={()=>props.submitPassword(props.spId, password)}>
                        Open
                    </Button>

                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}

ViewerPasswordDialog.propTypes = {
    open: PropTypes.any,
    handleClose: PropTypes.any,
    userId: PropTypes.any,
    evStore: PropTypes.any,
    submitPassword: PropTypes.any,
    spId: PropTypes.string
}

export default observer(ViewerPasswordDialog)